<shared-layout [menu]="menu$ | async" [links]="links$ | async">
  <ng-content></ng-content>
</shared-layout>